/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Col,
  Modal,
  Input,
  DatePicker,
  message,
} from 'antd';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import PercentageInput from 'components/PercentageInput';
import percentFormatter from 'utils/percentFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { getEstadosGlobales } from 'api/catalogos';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';
import { getDocumentosEmpleadosParams } from 'api/catalogos/documentosEmpleados';
import FormItem from 'antd/es/form/FormItem';
import Previewer from 'components/Previewer';
import API from 'utils/api';
import { getTiposDeDocumentos } from 'api/catalogos/tiposDeDocumentos';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import Uploader from 'components/Uploader';
import moment from 'moment';
import {
  deleteDocumentosJustificacion,
  getDocumentosJustificacion,
  getDocumentosJustificaciones,
  patchDocumentosJustificacion,
  postDocumentosJustificacion,
} from 'api/configuraciones/clock/Justificacion/JustificacionAdjuntos';

export const JustificacionAjuntosPermission = {
  permissionModel: 'documentojustificacionrelojchecador',
  catalogsModels: [],
  tabsModels: [],
};

const JustificacionAdjuntos = ({
  permissions,
  selected,
  disable,
  isBlocked,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState([]);
  const [esTransferencia, setEsTransferencia] = useState(false);
  const [esClabe, setEsClabe] = useState(false);
  const [tipoDeDocumento, setTipoDeDocumento] = useState();
  const [formFormaPago] = Form.useForm();
  const [porcentajes, setPorcentajes] = useState(0);
  const [editable, setEditable] = useState(false);
  const [porcentajeSeleccionado, setPorcentajeSeleccionado] = useState(0);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [currentFile, setCurrentFile] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [tiposDeDocumentos, setTiposDeDocumentos] = useState([]);
  const [pageActual, setPageActual] = useState(1);

  const formInstances = [
    form,
    formDatos,
    formFormaPago,
  ];

  // const fetchData = async () => {
  //   setLoading(true);
  //   const _data = await getDocumentosJustificaciones({ descuento_empleado: selected });
  //   setData(formatReceived(_data));
  //   setLoading(false);
  //   return _data;
  // };

  const getFechaServidor = async () => ({ fecha: new Date().toISOString() });

  const obtenerFechaServidorYSetear = async () => {
    try {
      const { fecha } = await getFechaServidor(); // retorna string tipo "2025-06-24T18:15:00Z"
      form.setFieldsValue({
        fecha_de_carga: moment(fecha), // ⬅️ convertir string ISO a moment
      });
    } catch (err) {
      message.error('No se pudo obtener la fecha del servidor');
    }
  };

  const baseURI = '/relojchecador/documentos-justificacion-reloj-checador';

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page, ...q } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await API.get(baseURI, { params: { page: cleanPage, ...q } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      const _selected = selected[0];
      const _data = await getDocumentosJustificaciones({ justificacion_reloj_checador: _selected });
      const { results } = _data;
      setData({ ..._data, results });
    };
    if (!selected) {
      setData([]);
      return;
    }
    fetchAll();
  }, [selected]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _estados,
        _tiposDeDocumentos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeDocumentos(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposDeDocumentos(_tiposDeDocumentos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setEsTransferencia(false);
    setEditable(false);
    setEsClabe(false);
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickAdd = async () => {
    onCancel();
    setVisible(true);
    // await obtenerFechaServidorYSetear();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setEditable(true);

    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);

    try {
      const documento = await getDocumentosJustificacion(match.id);

      /*
      // Convertir fecha correctamente
      if (documento.fecha_de_carga && typeof documento.fecha_de_carga === 'string') {
        documento.fecha_de_carga = moment(documento.fecha_de_carga);
      } */

      // Cargar en formularios
      form.setFieldsValue(formatReceived(documento));
      formDatos.setFieldsValue(formatReceived(documento));

      setVisible(true);
    } catch (error) {
      message.error('Error al cargar el documento.');
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();

      const rawValues = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };

      // Asegurar campo obligatorio
      const _selected = selected[0];
      rawValues.justificacion_reloj_checador = _selected;

      const formData = new FormData();
      Object.entries(rawValues).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === 'archivo' && value instanceof File) {
            formData.append(key, value);
          } else if (moment.isMoment(value)) {
            formData.append(key, value.format('YYYY-MM-DD'));
          } else {
            formData.append(key, value);
          }
        }
      });
      const [key] = selectedRowKeys;
      const saved = key
        ? await patchDocumentosJustificacion(key, formData)
        : await postDocumentosJustificacion(formData);

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDocumentosJustificacion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);

    const newRecord = {
      ...record,
      // fecha_de_carga: record.fecha_de_carga ? moment(record.fecha_de_carga) : null,
    };

    form.setFieldsValue(newRecord);
  };

  const onClickDownload = () => {
    const clone = [...(data?.results || [])];
    const [key] = selectedRowKeys;
    const match = clone.find((e) => e.id === key);

    if (match?.archivo) {
      // Usar la URL completa proporcionada por la API
      const fileUrl = match.archivo;

      // Crear un enlace de descarga y simular un click
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = match.archivo.split('/').pop(); // Extrae el nombre del archivo de la URL
      link.click();
    }
  };

  const limitMB = 5;
  const allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf'];

  const handleUploadChange = ({ file }) => {
    const realFile = file.originFileObj || file;

    if (!(realFile instanceof File)) {
      message.error('El archivo no es válido.');
      return;
    }

    const { name } = realFile;
    const extension = name.split('.').pop().toLowerCase();
    const baseName = name.replace(/\.[^/.]+$/, '');

    form.setFieldsValue({
      archivo: realFile,
      extension_del_documento: extension,
      nombre_del_documento: baseName,
    });
  };

  const esImagen = (file) => {
    if (!file || !file.archivo) return false; // Si no hay archivo, no es imagen
    const extensionRegex = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;
    const mimeTypeRegex = /^image\//;

    return mimeTypeRegex.test(file.type) || extensionRegex.test(file.archivo);
  };

  const getFileUrl = () => {
    if (!currentFile?.archivo) return null;
    if (currentFile.archivo.includes('?')) return currentFile.archivo;
    return `${currentFile.archivo}?t=${new Date().getTime()}`;
  };
  const fileUrl = getFileUrl();

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  /*
    {
      titleText: 'Fecha',
      dataIndex: 'fecha_de_carga',
      key: 'fecha_de_carga',
      width: 400,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    }, */
  const columns = [
    {
      titleText: 'Nombre De Documento',
      dataIndex: 'nombre_del_documento',
      key: 'nombre_del_documento',
      width: 300,
    },

    {
      titleText: 'Extension',
      dataIndex: 'extension_del_documento',
      key: 'extension_del_documento',
      width: 300,
    },

    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (_, register) => register.estados_globales.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          rowSelection={rowSelection}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          allowExport
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: onClickDownload, // Cambiar aquí
              icon: <DownloadOutlined />,
              text: 'Descargar Documento', // Cambiar el texto a 'Descargar'
              disabled: !selectedRowKeys.length,
            },
          ]}
          allowDelete={!disable}
          permission={permissions}
          allowExportPDF={false}
          disableAdd={disable || isBlocked}
        />
        <Modal
          open={open}
          width={700}
          closable={false}
          maskClosable={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Documento que lo justifica`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disable}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            disabled={disable}
          >
            {/**
            <Col xs={24} sm={8}>
              <Form.Item
                name="fecha_de_carga"
                label="Fecha de Carga"
                hasFeedback
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  disabled
                />
              </Form.Item>
            </Col>
 */}
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="nombre_del_documento"
                label="Nombre de Documento"
              >
                <Input disabled />
              </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="extension_del_documento"
                label="extension"
              >
                <Input disabled />

              </Form.Item>
            </Col>

            <Form.Item
              name="archivo"
              valuePropName="file"

            >
              <Uploader
                title="Documento"
                limitMB={limitMB}
                allowedExtensions={allowedExtensions}
                allowPreview={false}
                onChange={handleUploadChange}
              />
            </Form.Item>
          </Form>
        </Modal>
        <Previewer
          open={visiblePreview}
          setVisible={setVisiblePreview}
          iFrameUrl={fileUrl}
          isImage={esImagen(currentFile)}
        />

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Justificacion ${form.getFieldValue('nombre_del_documento')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
export default JustificacionAdjuntos;
